import { render, staticRenderFns } from "./partnerMovementsCategoryTable.vue?vue&type=template&id=2c5f1aab&"
import script from "./partnerMovementsCategoryTable.vue?vue&type=script&lang=ts&"
export * from "./partnerMovementsCategoryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports